module.exports = __webpack_public_path__ + "media/images/helloworld-889ddfb93c85454e7aadb4ee96ae80af.webp";